module.exports = __webpack_public_path__ + "static/media/services-icon-1.28f2f46c.svg";